<template>
  <SimpleModal :value="value" @hide="hide()" :closeOnBgClick="false">
    <div class="box box-height">
      <div v-if="computer.online" class="columns is-multiline">
        <div class="column is-12">
          <form name="commandForm" @submit.prevent="sendCommand(command)">
            <BInput
              v-model="command"
              :disabled="!$store.state.powershell.status.complete"
              icon="mdi-powershell"
              placeholder="Powershell command"
              name="input-powershell"
            ></BInput>
          </form>
        </div>
        <div class="column">
          <div class="buttons">
            <a
              class="button is-success is-small"
              :disabled="
                !computer.online || !$store.state.powershell.status.complete
              "
              @click="
                $store.state.powershell.status.complete
                  ? sendCommand(command)
                  : false
              "
              :class="{
                'is-loading': !$store.state.powershell.status.complete,
              }"
              >Send</a
            >
            <a
              class="button is-danger is-small"
              :disabled="
                !computer.online ||
                  $store.state.powershell.status.terminating ||
                  $store.state.powershell.status.complete
              "
              @click="
                !$store.state.powershell.status.complete &&
                !$store.state.powershell.status.terminating
                  ? sendCommand(':stop:')
                  : false
              "
              :class="{
                'is-loading': $store.state.powershell.status.terminating,
              }"
              >Terminate</a
            >

            <a
              class="button is-default is-small"
              :disabled="!$store.state.powershell.status.complete"
              @click="reset()"
              >Clear</a
            >
          </div>
        </div>
      </div>
      <div v-if="!computer.online" class="notification is-info">
        <i>The computer is offline.</i>
      </div>
      <pre
        v-show="
          computer.online ||
            (!computer.online && $store.state.powershell.lines.length !== 0)
        "
        id="pre-powershell"
        class="pre-powershell"
      >
      <span
  class="is-block"
  v-for="(line, index) of $store.state.powershell.lines"
  :key="index"
  :class="[{'has-text-danger' : line.type == 'error' },
  {'has-text-warning' : line.type == 'warning'},
  {'has-text-info' : line.type == 'information' },
  {'margin-bottom' : line.status == 'end' }]"
>{{line.value}}</span>
      </pre>
    </div>
  </SimpleModal>
</template>

<style scoped lang="css">
.pre-powershell {
  max-height: 60vh;
}

.box-height {
  min-height: 80vh;
}
</style>
<script>
import computerHelper from "@/utils/computer";
import { sendPowershellCommand } from "@/utils/socket";
import { focus, select } from "@/utils/document";

export default {
  props: {
    value: Boolean,
    computer: Object,
  },
  components: {
    SimpleModal: () => import("@/components/singles/SimpleModal.vue"),
    BInput: () => import("@/components/singles/BInput/component.vue"),
  },
  computed: {
    name() {
      return computerHelper.getName(this.computer);
    },
  },
  data() {
    return { command: "" };
  },
  created() {},

  mounted() {
    setTimeout(() => {
      focus("input-powershell");
    }, 100);
  },
  methods: {
    reset() {
      this.$store.commit("powershell/clear");
    },
    sendCommand(command) {
      this.$store.commit("powershell/setComputerUID", this.computer.uid);

      this.$store.commit("powershell/setStatus", {
        complete: false,
        terminating: false,
      });

      if (!sendPowershellCommand(this.computer.uid, command)) {
        this.$store.commit("powershell/setStatus", {
          complete: false,
          terminating: false,
        });

        this.$helpers.notify(
          "Disconnected",
          "No connection to the server.",
          "warning",
          -1
        );
      }
    },
    hide() {
      this.$emit("hide", false);
      this.$emit("input", false);
    },
  },
};
</script>
